import logger from '@eventbrite/client-logger';
import { logEvent } from '@eventbrite/statsig';
import isEmpty from 'lodash/isEmpty';
import { Dispatch } from 'redux';
import { updateOrderSurveyAnswersAfterPlacement } from '../../api/order';
import { STATSIG_EVENT_NAMES } from '../../constants/statsig';
import { FormSurveyAnswer } from '../../models/forms';
import { CheckoutState } from '../../state';
import { getFailedSurveyAnswersIds } from '../../utils/surveys';
import { handleAnalyticsTokenOnError } from '../tokens';

export const updateOrderWithOptionalOrganizerQuestions =
    (
        orderId: string,
        surveyAnswers: Array<FormSurveyAnswer>,
        skipErroredAnswers: boolean,
        optionalQuestionAnswerRatio: {
            optionalQuestionsTotal: string;
            optionalQuestionsAnswered: string;
            optionalQuestionsRatio: string;
            requiredQuestionsTotal: string;
            currentPage: string;
        },
    ) =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        if (isEmpty(surveyAnswers)) {
            logEvent(
                STATSIG_EVENT_NAMES.CHECKOUT_STEP_SUCCESS_ORGANIZER_QUESTIONS_RATIO,
                undefined,
                optionalQuestionAnswerRatio,
            );
            return;
        }

        try {
            await updateOrderSurveyAnswersAfterPlacement(
                orderId,
                surveyAnswers,
            );
        } catch (error) {
            logger.error(error);

            if (!skipErroredAnswers) {
                handleAnalyticsTokenOnError(dispatch, getState);
                throw error;
            }

            const validSurveyAnswers = _cleanErroredOptionalOrganizerQuestions(
                surveyAnswers,
                error,
            );
            try {
                await updateOrderSurveyAnswersAfterPlacement(
                    orderId,
                    validSurveyAnswers,
                );
            } catch (error) {
                logger.error(error);
                handleAnalyticsTokenOnError(dispatch, getState);
            }
        }

        logEvent(
            STATSIG_EVENT_NAMES.CHECKOUT_STEP_SUCCESS_ORGANIZER_QUESTIONS_RATIO,
            undefined,
            optionalQuestionAnswerRatio,
        );
    };

export const _cleanErroredOptionalOrganizerQuestions = (
    surveyAnswers: Array<FormSurveyAnswer>,
    error: Error,
) => {
    const failedAnswersIds = new Set(getFailedSurveyAnswersIds(error));
    return Object.keys(surveyAnswers)
        .filter((answerKey) => !failedAnswersIds.has(answerKey))
        .map((answerKey) => surveyAnswers[answerKey as unknown as number]);
};
